<template>
  <div class="login-and-reg" v-if="needToLoginOrReg">
    <div @click="closeThis" class="close_btn">
      <svg-icon name="Close"></svg-icon>
    </div>
    <!-- 登录 -->
    <div v-show="mainType == 'byaccount' || mainType == 'bycode'" class="container container1">
      <div class="main-left">
        <div class="left-title">迷你CAD</div>
        <!-- <template v-if="!qrcode.iframe">
          <div v-if="qrcode.tip_type != '3'" class="left-code">
            <div class="code-box" @click="retryGetCode">
              <img v-show="qrcode.img" :src="qrcode.img" alt="" />
              <div v-show="qrcode.tip_type != '0'" class="tips">
                <p v-if="qrcode.tip_type == '1'">{{ qrcode.txt }}</p>
                <template v-else-if="qrcode.tip_type == '2'">
                  <svg-icon class="get-again" name="Again"></svg-icon>
                  <p>{{ qrcode.txt }}</p>
                </template>
              </div>
            </div>
            <p class="code-title">微信扫码登录</p>
            <p class="code-intro">未注册的微信号将自动创建迷你CAD账号</p>
          </div>
          <div v-else class="left-scan-success">
            <svg-icon name="Scan-Success"></svg-icon>
            <p>扫码完成，请在手机上操作</p>
            <p class="unique-color cursor-pointer intro" @click="retryGetCode">重新扫码</p>
          </div>
        </template> -->
        <div class="qrcode-box">
          <div id="wechat-qrcode-container"></div>
          <p class="qrcode-title">微信扫码登录</p>
          <p class="qrcode-intro">打开微信扫一扫，绑定账号并登录</p>
        </div>
      </div>
      <div class="main-right">
        <ul class="right-part1">
          <li
            :class="{ active: item.value == mainType }"
            v-for="item in accountOrCode"
            @click="choseAccountOrCode(item)"
            :key="item.value"
          >
            {{ item.label }}
          </li>
        </ul>
        <div
          v-show="mainType == 'byaccount'"
          class="by-account"
          @keydown.enter="accountOrCodeLogin"
        >
          <div class="tip-error" v-show="tipError.show">
            <svg-icon name="Tips-Error"></svg-icon>
            <span v-html="tipError.txt"></span>
          </div>
          <div class="account-box">
            <svg-icon name="Login-User"></svg-icon>
            <el-input
              :class="{ 'was-error': tipError.type == '1' }"
              v-model.trim="byAccount.account"
              placeholder="请输入手机号/邮箱"
              @input="inputCancelErrorState"
              autocomplete="off"
            >
            </el-input>
          </div>
          <div class="pwd-box">
            <svg-icon class="pwd-icon" name="Login-Pwd"></svg-icon>
            <el-input
              v-model.trim="byAccount.pwd"
              :class="{ 'was-error': tipError.type == '2' }"
              :type="byAccount.showPwd ? 'text' : 'password'"
              placeholder="请输入密码"
              @input="inputCancelErrorState"
              autocomplete="new-password"
              name="no-autofill-pwd"
            >
            </el-input>
            <div class="show-btn" @click="byAccount.showPwd = !byAccount.showPwd">
              <svg-icon :name="byAccount.showPwd ? 'Login-PwdShow' : 'Login-PwdHide'"></svg-icon>
            </div>
          </div>
        </div>
        <div v-show="mainType == 'bycode'" class="by-code" @keydown.enter="accountOrCodeLogin">
          <div class="tip-error" v-show="tipError.show">
            <svg-icon name="Tips-Error"></svg-icon>
            <span v-html="tipError.txt"></span>
          </div>
          <el-input
            v-model.trim="byCode.tel"
            :class="{ 'was-error': tipError.type == '3' }"
            @input="inputCancelErrorState"
            placeholder="请输入手机号"
            autocomplete="off"
          >
            <template #prefix>
              <svg-icon name="Login-Phone"></svg-icon>
            </template>
          </el-input>
          <div class="get-code">
            <el-input
              v-model.trim="byCode.code"
              :class="{ 'was-error': tipError.type == '4' }"
              @input="inputCancelErrorState"
              type="text"
              placeholder="请输入验证码"
              autocomplete="off"
            >
              <template #prefix>
                <svg-icon name="Login-Code"></svg-icon>
              </template>
            </el-input>
            <div
              :class="['send-btn', 'unique-color', { wait_second: !byCode.canGet }]"
              @click="
                getPhoneCode({
                  form: byCode,
                  type: 'login',
                  errorMsg: '3'
                })
              "
            >
              {{ byCode.codeWord }}
            </div>
          </div>
        </div>
        <div class="right-tip1">
          <template v-if="mainType == 'byaccount'">
            <router-link class="unique-color" :to="forgetPwdToWhere" target="_blank" id="to_reset"
              >忘记密码</router-link
            >
          </template>
          <template v-if="mainType == 'bycode'">
            <span
              >收不到验证码？<span class="unique-color cursor-pointer" @click="toQqServe"
                >联系客服</span
              ></span
            >
          </template>
        </div>
        <div
          v-loading="loginLoading"
          element-loading-text="登录中..."
          :class="['right-main-btn', judgeLoginBtnState()]"
          @click="accountOrCodeLogin"
        >
          登录
        </div>
        <el-checkbox v-model="agreement">
          已阅读并同意
          <a class="unique-color" href="https://www.olcad.com/agreement.html" target="_blank"
            >用户协议</a
          >
          和
          <a class="unique-color" href="https://www.olcad.com/privacy.html" target="_blank"
            >隐私协议</a
          >
        </el-checkbox>
        <div class="right-tip2">
          <template v-if="mainType == 'byaccount'">
            <span>还没有账号？</span>
            <span class="unique-color cursor-pointer" @click="setMainType('register')"
              >免费注册</span
            >
          </template>
          <span v-else>未注册的手机号将自动创建迷你CAD账号</span>
        </div>
      </div>
    </div>
    <!-- 注册 || 微信绑定账号 -->
    <div v-show="mainType == 'register' || mainType == 'bindwechat'" class="container container2">
      <div class="main-left">
        <div class="left-title">
          <figure class="logo"></figure>
          <span>迷你CAD</span>
        </div>
        <div class="left-intro">
          <p>轻松改图画图·自由测量标注</p>
          <p>图纸云端同步·三端共用账号</p>
        </div>
      </div>
      <div class="main-right">
        <template v-if="mainType == 'register'">
          <ul class="right-part1">
            <li class="active">账号注册</li>
          </ul>
          <div class="register" @keydown.enter="registerBtn">
            <div class="tip-error" v-show="tipError.show">
              <svg-icon name="Tips-Error"></svg-icon>
              <span v-html="tipError.txt"></span>
            </div>
            <el-input
              v-model.trim="register.tel"
              :class="{ 'was-error': tipError.type == '5' }"
              @input="inputCancelErrorState"
              placeholder="请输入手机号"
              autocomplete="off"
            >
              <template #prefix>
                <svg-icon name="Login-Phone"></svg-icon>
              </template>
            </el-input>
            <div class="pwd-box">
              <svg-icon class="pwd-icon" name="Login-Pwd"></svg-icon>
              <el-input
                v-model.trim="register.pwd"
                :class="{ 'was-error': tipError.type == '6' }"
                @input="inputCancelErrorState"
                :type="register.showPwd ? 'text' : 'password'"
                placeholder="请输入密码"
                autocomplete="new-password"
                name="no-autofill-pwd"
              >
              </el-input>
              <div class="show-btn" @click="register.showPwd = !register.showPwd">
                <svg-icon :name="register.showPwd ? 'Login-PwdShow' : 'Login-PwdHide'"></svg-icon>
              </div>
            </div>
            <div class="get-code">
              <el-input
                v-model.trim="register.code"
                :class="{ 'was-error': tipError.type == '7' }"
                @input="inputCancelErrorState"
                type="text"
                placeholder="请输入验证码"
                autocomplete="off"
              >
                <template #prefix>
                  <svg-icon name="Login-Code"></svg-icon>
                </template>
              </el-input>
              <div
                :class="['send-btn', 'unique-color', { wait_second: !register.canGet }]"
                @click="
                  getPhoneCode({
                    form: register,
                    type: 'rgister',
                    errorMsg: '5'
                  })
                "
              >
                {{ register.codeWord }}
              </div>
            </div>
          </div>
          <div
            v-loading="regLoading"
            element-loading-text="注册中..."
            :class="['right-main-btn', 'register-btn', { disabled: !register.could }]"
            @click="registerBtn"
          >
            免费注册
          </div>
          <div class="right-tip2 register-right-tip2">
            <span>已有迷你CAD账号？</span>
            <span class="unique-color cursor-pointer" @click="setMainType('byaccount')"
              >立即登录</span
            >
          </div>
        </template>
        <template v-else-if="mainType == 'bindwechat'">
          <div class="back-login" @click="backToAccount">&lt;返回</div>
          <ul class="right-part1">
            <li class="active">绑定账号</li>
          </ul>
          <div class="bind-wechat">
            <div class="tip-error" v-show="tipError.show">
              <svg-icon name="Tips-Error"></svg-icon>
              <span v-html="tipError.txt"></span>
            </div>
            <el-input
              v-model.trim="bindWechat.tel"
              :class="{ 'was-error': tipError.type == '8' }"
              @input="inputCancelErrorState"
              placeholder="请输入手机号"
              autocomplete="off"
            >
              <template #prefix>
                <svg-icon name="Login-Phone"></svg-icon>
              </template>
            </el-input>
            <div class="get-code">
              <el-input
                v-model.trim="bindWechat.code"
                :class="{ 'was-error': tipError.type == '9' }"
                @input="inputCancelErrorState"
                type="text"
                placeholder="请输入验证码"
                autocomplete="off"
              >
                <template #prefix>
                  <svg-icon name="Login-Code"></svg-icon>
                </template>
              </el-input>
              <div
                :class="['send-btn', 'unique-color', { wait_second: !bindWechat.canGet }]"
                @click="
                  getPhoneCode({
                    form: bindWechat,
                    type: 'bind',
                    errorMsg: '8'
                  })
                "
              >
                {{ bindWechat.codeWord }}
              </div>
            </div>
          </div>
          <div class="right-tip1">
            <span
              >收不到验证码？<span class="unique-color cursor-pointer" @click="toQqServe"
                >联系客服</span
              ></span
            >
          </div>
          <div
            v-loading="bindLoading"
            element-loading-text="绑定中..."
            :class="['right-main-btn', { disabled: !bindWechat.could }]"
            @click="bindWechatBtn(0)"
          >
            去绑定
          </div>
          <el-checkbox v-model="agreement">
            已阅读并同意
            <a class="unique-color" href="https://www.olcad.com/agreement.html" target="_blank"
              >用户协议</a
            >
            和
            <a class="unique-color" href="https://www.olcad.com/privacy.html" target="_blank"
              >隐私协议</a
            >
          </el-checkbox>
          <div class="right-tip2">未注册的手机号将自动创建迷你CAD账号</div>
        </template>
      </div>
    </div>

    <el-dialog v-model="dialogTips.show" class="dialog-tips" :modal="false" title="提示">
      <div class="dialog-contain">
        <template v-if="dialogTips.mainType == '1'">
          依据相关政策要求，为了更好地体验迷你CAD服务，请查看并同意
          <a class="unique-color" href="https://www.olcad.com/agreement.html" target="_blank"
            >用户协议</a
          >
          和
          <a class="unique-color" href="https://www.olcad.com/privacy.html" target="_blank"
            >隐私协议</a
          >。
        </template>
        <template v-else-if="dialogTips.mainType == '2'">
          当前账号已被绑定，是否强制绑定？
        </template>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="tipsCancel">暂不</el-button>
          <el-button type="primary" @click="tipsConfirm">{{ dialogTips.btnTxt }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
  <div class="mask" v-show="needToLoginOrReg"></div>
</template>

<script setup>
import globalfun from '@/assets/js/globalfun'
import tool from '@/assets/js/tool'
import msg from '@/utils/message'
import md5 from '@/assets/js/md5.js'
import { useMapState } from '@/assets/js/use_storemap'
import {
  apiGetAppletCode,
  apiGetAppletStatus,
  apiAccountPwdLogin,
  apiGetPhoneCode,
  apiPhoneCodeLogin,
  apiToRegister,
  apiGetSetInfo,
  apiFastLogin,
  apiWxBindTelphone
} from '@/api/modules/cad_api'
import { useRoute, useRouter } from 'vue-router'
import { ref, watchEffect, onBeforeMount, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'

/* !!! 必须加 v-if 来 注册||销毁 该组件 !!! */
/* --- props --- */
const props = defineProps({
  needToLoginOrReg: {
    type: Boolean
  },
  forgetPwdToWhere: {
    type: String
  } // “忘记密码” 按钮跳往哪里
})
/* --- emits --- */
const emits = defineEmits(['update:needToLoginOrReg'])

const { baseURL } = useMapState({
  baseURL: state => state.realm.baseURL
})
const store = useStore()
const route = useRoute()
const router = useRouter()

const wxConfig = {
  self_redirect: true, // true：自主扫码模式，false：跳转模式
  id: 'wechat-qrcode-container', // 容器ID（需和模板中的容器一致）
  // stylelite: 1,
  appid: '', // 公众号/开放平台APPID
  scope: 'snsapi_login', // 授权类型
  redirect_uri: encodeURIComponent('https://app.aec188.com/cad/wechat'), // 回调地址
  state: 'STATE_STRING', // 自定义防CSRF参数
  style: 'black', // 二维码样式（可选：black/white）
  href: 'https://app.aec188.com/css/wxScan.css' // 自定义CSS样式，stylelite 不为 1 时可生效
}
const qrcode = ref({
  img: '',
  qrcode_id: '',
  tip_type: '0', // 0: 关闭；1：文本提示；2：重新获取二维码；3：扫码成功
  txt: '获取中…',
  timer: null,
  times: 0,
  iframe: false // 微信快捷登录是否生效：false（未）
})
let mainType = ref('byaccount') // 当前处于什么界面。byaccount：账号密码登录；bycode：短信验证登录；register：账号注册；bindwechat：绑定账号
const accountOrCode = ref([
  { value: 'byaccount', label: '账号密码登录' },
  { value: 'bycode', label: '短信验证登录' }
])
const byAccount = ref({
  account: '',
  pwd: '',
  showPwd: false, // 是否显示密码? false: 否
  could: false // 是否可以点击登录? false: 否
})
const byCode = ref({
  tel: '',
  code: '',
  could: false,
  canGet: true, // 是否可以再次获取验证码? true: 可
  codeWord: '获取验证码'
})
let loginLoading = ref(false)
let agreement = ref(false) // 是否点击了同意协议
const register = ref({
  tel: '',
  pwd: '',
  showPwd: false,
  code: '',
  could: false,
  canGet: true,
  codeWord: '获取验证码'
})
let regLoading = ref(false)
const bindWechat = ref({
  tel: '',
  code: '',
  could: false,
  canGet: true,
  codeWord: '获取验证码',
  wxId: ''
})
let bindLoading = ref(false)
let tipError = ref({
  show: false,
  txt: '',
  type: '' // 1: 账号密码登录->账号有误；2：账号密码登录->密码有误；3：短信验证登录->手机号有误；4：短信验证登录->验证码有误；5：注册->手机号有误；6：注册->密码有误；7：注册->验证码有误；8：绑定账号->账号有误；9：绑定账号->验证码有误
})
const dialogTips = ref({
  show: false,
  mainType: '1', // 弹窗类型。1：未勾选协议；2：是否强制绑定微信
  type: '1', // 未勾选协议提示。1：账号||短信验证登录；2：注册; 3：绑定账号
  btnTxt: '同意并登录'
})

onBeforeMount(() => {
  // getAppletCode()
  if (store.state.cad.login && store.state.cad.login.show) {
    setMainType(store.state.cad.login.type)
  }
})

onBeforeUnmount(() => {
  cleanup()
  const script = document.getElementById('wxLoginScript')
  if (script) document.body.removeChild(script)
  window.removeEventListener('message', handleMessage)
})

onMounted(() => {
  getSetInfo()
})

const getSetInfo = async () => {
  try {
    const res = await apiGetSetInfo()

    if (res.code == 2) {
      let pp = decodeURIComponent(atob(res.param1.pp))
      initWechatLogin(pp)
    } else {
      qrcode.value.iframe = false
    }
  } catch (error) {
    qrcode.value.iframe = false
  }
}

// 微信快捷登录
const initWechatLogin = pp => {
  wxConfig.appid = pp
  wxConfig.state = Math.random().toString(36).substring(2, 15)
  localStorage.setItem('wechat_state', wxConfig.state)

  // 动态加载微信JS SDK
  if (!document.getElementById('wxLoginScript')) {
    const script = document.createElement('script')
    script.id = 'wxLoginScript'
    script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    script.onload = () => {
      // JS加载完成后初始化
      new window.WxLogin({
        ...wxConfig,
        onReady: isReady => {
          qrcode.value.iframe = isReady
          if (isReady) {
            clearTimeout(qrcode.value.timer)
          }
        }
      })
    }

    document.body.appendChild(script)
  } else {
    // 已加载时直接初始化
    new window.WxLogin({ ...wxConfig })
  }

  // 绑定消息监听
  window.addEventListener('message', handleMessage)
}
const cleanup = () => {
  const container = document.getElementById(wxConfig.id)
  if (container) container.innerHTML = ''
}
const validateState = receivedState => {
  const originalState = localStorage.getItem('wechat_state')
  localStorage.removeItem('wechat_state') // 一次性校验
  return originalState === receivedState
}

const handleMessage = event => {
  if (event.data.type === 'wechat-login') {
    const { code, state } = event.data

    // 1. 校验state合法性（防CSRF）
    if (!validateState(state)) {
      console.error('非法请求: state不匹配')
      return
    }
    fastLogin(code)
    window.removeEventListener('message', handleMessage)
  }
}

const fastLogin = code => {
  apiFastLogin({
    code
  }).then(res => {
    if (res.code == 1) {
      if (res.param1.user_token) {
        setStoreCommit(res.param1.user_token, 'wx')
        return
      }

      if (!res.param1.user_id) {
        setMainType('bindwechat')
        bindWechat.value.wxId = res.param1.wx_id
      }
    } else {
      msg.e({ msg: res.msg || '微信登录失败，请稍后再试' })
    }
  })
}

// 获取小程序登录二维码
const getAppletCode = async () => {
  qrcode.value.tip_type = '1'
  qrcode.value.txt = '获取中…'
  try {
    const res = await apiGetAppletCode()
    if (res.code == 1) {
      qrcode.value.tip_type = '0'
      qrcode.value.img = res.param1.url
      qrcode.value.qrcode_id = res.param1.qrcode_id
      getAppletState()
    } else {
      qrcode.value.tip_type = '2'
      qrcode.value.txt = '请点击刷新'
    }
  } catch (error) {
    qrcode.value.tip_type = '2'
    qrcode.value.txt = '请点击刷新'
  }
}

const getAppletState = () => {
  if (qrcode.value.iframe) return
  clearTimeout(qrcode.value.timer)

  const check = async (retryCount = 0) => {
    try {
      qrcode.value.times = retryCount + 1
      if (qrcode.value.times >= 60) {
        qrcode.value.tip_type = '2'
        qrcode.value.txt = '请点击刷新'
        return
      }

      const res = await apiGetAppletStatus({
        qrcode_id: qrcode.value.qrcode_id
      })

      if (res.code == 1) {
        setStoreCommit(res.param1.user_token, 'wx')
      } else if (res.code == 2) {
        // 二位码过期
        qrcode.value.tip_type = '2'
        qrcode.value.txt = '请点击刷新'
      } else if (res.code == 5) {
        qrcode.value.tip_type = '2'
        qrcode.value.txt = '用户不存在，点击刷新'
      } else if (res.code == 6) {
        qrcode.value.tip_type = '2'
        qrcode.value.txt = '微信绑定异常，点击再试'
      } else {
        if (res.code == 4) {
          qrcode.value.tip_type = '3'
        }
        qrcode.value.timer = setTimeout(() => check(retryCount + 1), 1000)
      }
    } catch (error) {
      clearInterval(qrcode.value.timer)
    }
  }

  // 首次执行检查
  qrcode.value.timer = setTimeout(check, 1000)
}

const retryGetCode = () => {
  if (qrcode.value.tip_type == '2' || qrcode.value.tip_type == '3') {
    qrcode.value.tip_type == '0'
    clearTimeout(qrcode.value.timer)
    getAppletCode()
  }
}

const choseAccountOrCode = params => {
  setMainType(params.value)
}

const toQqServe = tool.throttle(function () {
  globalfun.customerService('kefu_cad')
})

const judgeLoginBtnState = () => {
  if (mainType.value == 'byaccount') {
    if (byAccount.value.could) {
      return ''
    } else {
      return 'disabled'
    }
  } else if (mainType.value == 'bycode') {
    if (byCode.value.could) {
      return ''
    } else {
      return 'disabled'
    }
  }
}

const inputCancelErrorState = () => {
  tipError.value.type = ''
  tipError.value.show = false
}

// 获取二维码
const getPhoneCode = tool.throttle(function (options) {
  const { form, type, errorMsg } = options
  if (!tool.isTelephone(form.tel)) {
    setShowLoginErr(errorMsg, '请输入正确的手机号')
  } else {
    if (form.canGet) {
      apiGetPhoneCode({
        account: form.tel,
        type: type
      }).then(res => {
        if (res.code === 1) {
          tipError.value.show = false
          getCodeDownTime(60, form)
        } else if (res.code === 3) {
          setShowLoginErr('', '60s内请勿重复发送')
        } else if (res.code === 4) {
          setShowLoginErr('', res.msg)
        } else {
          msg.e({ msg: res.msg || '获取验证码失败，请稍后再试' })
        }
      })
    }
  }
})
function getCodeDownTime(curTime, form) {
  form.codeWord = '' + curTime + '秒后重发'
  form.canGet = false

  let timer = setInterval(() => {
    curTime--
    form.codeWord = '' + curTime + '秒后重发'

    if (curTime <= 0) {
      clearInterval(timer)
      form.codeWord = '获取验证码'
      form.canGet = true
    }
  }, 1000)
}

function setMainType(type) {
  mainType.value = type
  inputCancelErrorState()
}

function setShowLoginErr(type, txt) {
  tipError.value.show = true
  tipError.value.txt = txt
  tipError.value.type = type
}

async function setStoreCommit(user_token, login_form) {
  store.commit('user/setUserToken', user_token)
  store.commit('setLoginForm', login_form)
  store.commit('setUserInfoTime', new Date().getTime())

  if (route.query.personal == 'true') {
    await router.push('/personal')
  }

  tool.reloadWeb()
}

// 账号密码 || 手机验证码 登录
const accountOrCodeLogin = () => {
  if (!byAccount.value.could && !byCode.value.could) return

  if (!agreement.value) {
    setTipsBtnTxt('1', '1', '同意并登录')
    return
  }

  loginLoading.value = true
  if (mainType.value == 'byaccount') {
    try {
      apiAccountPwdLogin({
        account: byAccount.value.account,
        password: md5.hex_md5(byAccount.value.pwd)
      }).then(res => {
        if (res.code == 1) {
          setStoreCommit(res.param1.user_token, 'account')
        } else if (res.code == 3) {
          setShowLoginErr('1', '此用户不存在')
        } else if (res.code == 5) {
          setShowLoginErr('2', '密码错误')
        } else if (res.code == 4) {
          setShowLoginErr(
            '',
            `尚未设置密码，
      <a style="color: #0082F0" href="${baseURL.value}/user/dealRpstone?haspwd=no"
      target='_blank'>点击设置</a>`
          )
        } else {
          msg.e({ msg: res.msg || '登录失败，请稍后再试' })
        }
        loginLoading.value = false
      })
    } catch (error) {
      msg.e({ msg: '登录失败，请稍后再试' })
      loginLoading.value = false
    }
  } else if (mainType.value == 'bycode') {
    try {
      apiPhoneCodeLogin({
        account: byCode.value.tel,
        code: byCode.value.code
      }).then(res => {
        if (res.code == 1) {
          setStoreCommit(res.param1.user_token, 'phone')
        } else if (res.code == 3) {
          setShowLoginErr('4', '验证码有误')
        } else {
          msg.e({ msg: res.msg || '登录失败，请稍后再试' })
        }
        loginLoading.value = false
      })
    } catch (error) {
      msg.e({ msg: '登录失败，请稍后再试' })
      loginLoading.value = false
    }
  }
}

// 注册
const registerBtn = () => {
  if (!register.value.could) return

  if (tool.includeSpace(register.value.pwd)) {
    setShowLoginErr('6', '密码不能含有空格')
  } else if (register.value.pwd.length < 6) {
    setShowLoginErr('6', '密码长度不能小于6位')
  } else if (register.value.pwd.length > 12) {
    setShowLoginErr('6', '密码长度不能大于12位')
  } else {
    regLoading.value = true
    try {
      apiToRegister({
        account: register.value.tel,
        password: md5.hex_md5(register.value.pwd),
        code: register.value.code
      }).then(async res => {
        if (res.code == 1) {
          msg.s({ msg: '注册成功，即将自动登录' })
          store.commit('user/setUserToken', res.param1.user_token)
          store.commit('setLoginForm', 'account')
          store.commit('setUserInfoTime', new Date().getTime())
          setTimeout(() => {
            tool.reloadWeb()
          }, 500)
        } else if (res.code == 3) {
          setShowLoginErr('7', '验证码有误')
        } else {
          msg.e({ msg: res.msg || '注册失败，请稍后再试' })
        }
        regLoading.value = false
      })
    } catch (error) {
      msg.e({ msg: '注册失败，请稍后再试' })
      regLoading.value = false
    }
  }
}

// 绑定账号。type：0（手机号未绑定账号）；1（强制绑定微信）
const bindWechatBtn = type => {
  if (!bindWechat.value.could) return

  if (!agreement.value) {
    setTipsBtnTxt('1', '3', '同意并绑定')
    return
  }
  bindLoading.value = true

  apiWxBindTelphone({
    account: bindWechat.value.tel,
    code: bindWechat.value.code,
    type,
    wx_id: bindWechat.value.wxId
  }).then(res => {
    if (res.code == 1) {
      setStoreCommit(res.param1.user_token, 'wx')
    } else if (res.code == 5) {
      // 需要强制绑定
      setTipsBtnTxt('2', '', '强制绑定')
    } else {
      msg.e({ msg: res.msg || '绑定失败，请稍后再试' })
    }
    bindLoading.value = false
  })
}

const setTipsBtnTxt = (mainType, type, btnTxt) => {
  dialogTips.value.mainType = mainType
  dialogTips.value.type = type
  dialogTips.value.btnTxt = btnTxt
  dialogTips.value.show = true
}

const backToAccount = () => {
  setMainType('byaccount')
  getSetInfo()
}

const tipsCancel = () => {
  dialogTips.value.show = false
}

const tipsConfirm = () => {
  if (dialogTips.value.mainType == '1') {
    agreement.value = true
    if (dialogTips.value.type == '1') {
      accountOrCodeLogin()
    } else if (dialogTips.value.type == '2') {
      registerBtn()
    } else if (dialogTips.value.type == '3') {
      bindWechatBtn(0)
    }
  } else if (dialogTips.value.mainType == '2') {
    bindWechatBtn(1)
  }

  tipsCancel()
}

// 关闭此组件
const closeThis = () => {
  store.state.cad.login.show = false
  emits('update:needToLoginOrReg', false)
}

watchEffect(() => {
  if (byAccount.value.account && byAccount.value.pwd) {
    byAccount.value.could = true
  } else {
    byAccount.value.could = false
  }

  if (byCode.value.code && byCode.value.tel) {
    byCode.value.could = true
  } else {
    byCode.value.could = false
  }

  if (register.value.tel && register.value.pwd && register.value.code) {
    register.value.could = true
  } else {
    register.value.could = false
  }

  if (bindWechat.value.tel && bindWechat.value.code) {
    bindWechat.value.could = true
  } else {
    bindWechat.value.could = false
  }
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_make.scss';
@import '@/assets/scss/common.scss';
$--login-color1: #0082f0;

.login-and-reg {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  line-height: 1.5;
  background: #fff;
  user-select: none;
  @include responsive-style(
    (
      width: 750px,
      height: 442px,
      border: 1px solid #0082f0
    )
  );

  .close_btn {
    position: absolute;
    top: 0;
    z-index: 99;
    cursor: pointer;
    @include responsive-style(
      (
        right: 4px,
        padding: 10px
      )
    );

    &:hover {
      .svg-icon {
        color: $--themecolor;
      }
    }

    .svg-icon {
      color: #979797;

      @include responsive-style(
        (
          width: 16px,
          height: 16px
        )
      );
    }
  }

  .container {
    display: flex;
    width: 100%;
    height: 100%;

    .main-left,
    .main-right {
      height: 100%;
    }

    .main-left {
      @include responsive-style(
        (
          width: 338px
        )
      );
    }

    .main-right {
      flex: 1;
      @include responsive-style(
        (
          padding: 40px 61px
        )
      );

      .right-part1 {
        display: flex;
        align-items: center;
        @include responsive-style(
          (
            margin-bottom: 32px
          )
        );

        li {
          position: relative;
          font-weight: 500;
          color: #6b6e75;
          cursor: pointer;
          @include responsive-style(
            (
              padding: 8px 0,
              margin-right: 36px,
              font-size: 20px
            )
          );

          &.active {
            color: #000;

            &::after {
              content: '';
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              background: $--login-color1;
              @include responsive-style(
                (
                  width: 120px,
                  height: 4px
                )
              );
            }
          }

          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      :deep(.el-input) {
        @include responsive-style(
          (
            width: 100%,
            height: 46px,
            margin-bottom: 10px
          )
        );

        &.was-error {
          .el-input__wrapper {
            @include responsive-style(
              (
                box-shadow: 0 0 0 2px #f24822 inset
              )
            );
          }
        }

        .el-input__wrapper {
          @include responsive-style(
            (
              padding: 0 10px,
              border-radius: 4px,
              box-shadow: 0 0 0 1px #e0e0e0 inset
            )
          );

          &.is-focus {
            @include responsive-style(
              (
                box-shadow: 0 0 0 1px $--login-color1 inset
              )
            );
          }
        }

        .svg-icon {
          @include responsive-style(
            (
              width: 30px,
              height: 30px,
              margin-right: 6px
            )
          );
        }

        .el-input__inner {
          height: 100%;
          line-height: 1;
          @include responsive-style(
            (
              font-size: 14px,
              color: #000
            )
          );
        }
      }

      .right-tip1 {
        text-align: right;
        color: #828282;
        @include responsive-style(
          (
            font-size: 12px
          )
        );
      }

      .right-main-btn {
        width: 100%;
        color: #f2f2f2;
        font-weight: 500;
        text-align: center;
        background-color: $--login-color1;
        cursor: pointer;
        @include responsive-style(
          (
            height: 46px,
            border-radius: 4px,
            padding: 12px 0 10px,
            margin: 24px auto 10px
          )
        );

        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      :deep(.el-checkbox) {
        justify-content: center;
        width: 100%;
        height: auto;

        .el-checkbox__label {
          color: #6b6e75;
          @include responsive-style(
            (
              padding-left: 4px,
              font-size: 12px
            )
          );
        }
      }

      .right-tip2 {
        display: flex;
        justify-content: center;
        color: #828282;
        text-align: center;
        @include responsive-style(
          (
            margin-top: 26px,
            font-size: 12px
          )
        );

        span {
          @include responsive-style(
            (
              padding: 10px
            )
          );
          padding-right: 0;
        }

        .cursor-pointer {
          padding-left: 0;
          @include responsive-style(
            (
              padding-right: 10px
            )
          );
        }
      }

      .account-box {
        position: relative;
        width: 100%;
        @include responsive-style(
          (
            margin-bottom: 10px
          )
        );

        .svg-icon {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          @include responsive-style(
            (
              left: 10px,
              width: 30px,
              height: 30px
            )
          );
        }

        :deep(.el-input) {
          margin-bottom: 0;
        }

        :deep(.el-input__wrapper) {
          padding: 0;
          box-shadow: none;

          &.is-focus {
            box-shadow: none;

            .el-input__inner {
              @include responsive-style(
                (
                  box-shadow: 0 0 0 1px $--login-color1 inset
                )
              );
            }
          }

          .el-input__inner {
            @include responsive-style(
              (
                padding: 0 10px 0 46px,
                border-radius: 4px,
                box-shadow: 0 0 0 1px #e0e0e0 inset
              )
            );
          }
        }
      }

      .pwd-box {
        position: relative;
        @include responsive-style(
          (
            margin-bottom: 10px
          )
        );

        .pwd-icon {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          @include responsive-style(
            (
              left: 10px,
              width: 30px,
              height: 30px
            )
          );
        }

        :deep(.el-input) {
          margin-bottom: 0;
        }

        :deep(.el-input__wrapper) {
          padding: 0;
          box-shadow: none;

          &.is-focus {
            box-shadow: none;

            .el-input__inner {
              @include responsive-style(
                (
                  box-shadow: 0 0 0 1px $--login-color1 inset
                )
              );
            }
          }

          .el-input__inner {
            @include responsive-style(
              (
                padding: 0 52px 0 46px,
                border-radius: 4px,
                box-shadow: 0 0 0 1px #e0e0e0 inset
              )
            );
          }
        }

        .show-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-45%);
          cursor: pointer;
          @include responsive-style(
            (
              right: 5px,
              padding: 5px
            )
          );

          .svg-icon {
            @include responsive-style(
              (
                width: 24px,
                height: 24px
              )
            );
          }
        }
      }

      .get-code {
        position: relative;

        :deep(.el-input__wrapper) {
          @include responsive-style(
            (
              padding-right: 90px
            )
          );
        }

        .send-btn {
          position: absolute;
          cursor: pointer;
          @include responsive-style(
            (
              top: 7px,
              right: 5px,
              padding: 5px
            )
          );

          &.wait_second {
            color: #97999b;
          }
        }
      }

      .by-account,
      .by-code,
      .register,
      .bind-wechat {
        position: relative;

        .tip-error {
          position: absolute;
          left: 0;
          display: flex;
          align-items: center;
          @include responsive-style(
            (
              top: -20px,
              font-size: 12px,
              color: #ff4040
            )
          );

          .svg-icon {
            @include responsive-style(
              (
                width: 16px,
                height: 16px,
                margin-right: 3px
              )
            );
          }
        }
      }
    }
  }

  .container1 {
    .main-left {
      overflow: hidden;
      @include responsive-style(
        (
          padding: 58px 50px,
          border-right: 1px solid #ebebeb
        )
      );
    }

    .left-title {
      color: $--login-color1;
      text-align: center;
      font-weight: 700;
      @include responsive-style(
        (
          font-size: 28px
        )
      );
    }

    .left-code {
      .code-box {
        position: relative;
        @include responsive-style(
          (
            width: 192px,
            height: 192px,
            padding: 12px,
            border-radius: 10px,
            margin: 30px auto 20px,
            border: 2px solid #fafafa
          )
        );

        img {
          width: 100%;
          height: 100%;
        }

        .tips {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 100%;
          height: 100%;
          color: $--login-color1;
          background-color: rgba(255, 255, 255, 0.9);

          .get-again {
            @include responsive-style(
              (
                width: 50px,
                height: 50px
              )
            );
          }
        }
      }

      .code-title {
        color: #222529;
        font-weight: 500;
        text-align: center;
        @include responsive-style(
          (
            font-size: 16px
          )
        );
      }

      .code-intro {
        color: #828282;
        text-align: center;
        @include responsive-style(
          (
            font-size: 12px
          )
        );
      }
    }

    .left-scan-success {
      text-align: center;
      color: #666;

      .svg-icon {
        @include responsive-style(
          (
            width: 180px,
            height: 180px,
            margin: 30px 0
          )
        );
      }

      .intro {
        @include responsive-style(
          (
            padding: 8px 0
          )
        );
      }

      p {
        @include responsive-style(
          (
            font-size: 12px
          )
        );
      }
    }

    .qrcode-box {
      @include make-attributes-custom(xl, ()) {
        transform: scale(1.2);
        margin-top: 50px;
      }
      @include make-attributes-custom(mx, ()) {
        transform: scale(2);
        margin-top: 163px;
      }

      .qrcode-title {
        color: #222529;
        font-weight: 500;
        text-align: center;
        margin-top: 20px;
        font-size: 16px;
      }

      .qrcode-intro {
        color: #828282;
        text-align: center;
        font-size: 12px;
      }

      #wechat-qrcode-container {
        width: 172px;
        height: 172px;
        border-radius: 10px;
        margin: 30px auto 20px;
        border: 2px solid #fafafa;
      }
    }
  }

  .container2 {
    .main-left {
      position: relative;
      height: 100%;
      @include make-backgroundimage-custom(
        lg,
        (
          name: '@/assets/img/cad/register_img1',
          extname: 'png'
        )
      );
      @include make-backgroundimage-custom(
        xl,
        (
          name: '@/assets/img/cad/register_img1-xl',
          extname: 'png'
        )
      );
      @include make-backgroundimage-custom(
        mx,
        (
          name: '@/assets/img/cad/register_img1-mx',
          extname: 'png'
        )
      );
      background-size: cover;

      .left-title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $--login-color1;
        font-weight: 700;
        @include responsive-style(
          (
            margin-top: 40px,
            font-size: 28px
          )
        );

        figure.logo {
          @include responsive-style(
            (
              margin-right: 12px
            )
          );
          @include make-backgroundimage-custom(
            lg,
            (
              name: '@/assets/img/cad/logo',
              extname: 'png',
              width: 60,
              height: 60
            )
          );
          @include make-backgroundimage-custom(
            xl,
            (
              name: '@/assets/img/cad/logo-xl',
              extname: 'png',
              width: 72,
              height: 72
            )
          );
          @include make-backgroundimage-custom(
            mx,
            (
              name: '@/assets/img/cad/logo-mx',
              extname: 'png',
              width: 120,
              height: 120
            )
          );
        }
      }

      .left-intro {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        color: #4b4f57;
        text-align: center;
        font-weight: 500;
        @include responsive-style(
          (
            bottom: 44px,
            font-size: 14px
          )
        );
      }
    }

    .main-right {
      position: relative;

      .right-part1 {
        justify-content: center;
      }

      .register-btn {
        @include responsive-style(
          (
            margin: 14px 0 26px
          )
        );
      }

      .register-right-tip2 {
        margin-top: 0;
      }
    }

    .back-login {
      position: absolute;
      color: $--login-color1;
      cursor: pointer;
      @include responsive-style(
        (
          left: 10px,
          top: 10px,
          padding: 10px
        )
      );
    }
  }

  .unique-color {
    color: $--login-color1;
  }

  :deep(.el-checkbox__inner) {
    @include responsive-style(
      (
        width: 14px,
        height: 14px
      )
    );

    &::after {
      @include responsive-style(
        (
          left: 4px,
          top: 1px,
          width: 3px,
          height: 7px
        )
      );
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  :deep(.dialog-tips) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0;
    @include responsive-style(
      (
        width: 422px,
        padding: 0 24px 24px,
        border-radius: 8px,
        box-shadow: 0px 8px 16px 0px rgba(11, 25, 37, 0.1),
        border: 1px solid #e8e8e9
      )
    );

    .el-dialog__header {
      @include responsive-style(
        (
          padding: 19px 0,
          border-bottom: 1px solid #e8e8e9
        )
      );

      .el-dialog__title {
        color: #000;
        line-height: 1;
        @include responsive-style(
          (
            font-size: 18px
          )
        );
      }

      .el-dialog__headerbtn {
        @include responsive-style(
          (
            top: 6px,
            right: 17px,
            width: 54px,
            height: 54px
          )
        );
      }

      .el-dialog__headerbtn:hover .el-dialog__close {
        color: $--themecolor;
      }
    }

    .el-dialog__body {
      color: #444e63;
      @include responsive-style(
        (
          padding: 20px 0
        )
      );
    }

    .el-dialog__footer {
      padding: 0;

      .el-button {
        background-color: transparent;
        @include responsive-style(
          (
            height: 32px,
            padding: 6px 20px,
            border-radius: 4px,
            border: 1px solid #ced0d1,
            color: #444e63,
            font-size: 14px
          )
        );
      }

      .el-button--primary {
        border-color: $--login-color1;
        color: #fff;
        background-color: $--login-color1;
      }
    }
  }

  :deep(.el-loading-spinner) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .circular {
      display: none;
    }
  }
}

.mask {
  z-index: 1000;
}
</style>
